module.exports = __webpack_public_path__ + "static/media/jsIcon.bbc5738c.svg";